export const FORGELINC_NAME = "ForgeLinc";
export const FORGELINC_KEY = "linkforge";

const KNOWN_BUSINESS_NAMES = {
  linkforge: FORGELINC_NAME,
  gearlinc: "GearLinc",
  gamelinc: "GameLinc",
  commandlinc: "CommandLinc",
  focuslinc: "FocusLinc",
  buildlinc: "BuildLinc",
};

export function displayProductText(value) {
  return String(value || "")
    .replaceAll("LinkWorks", "LincWerks")
    .replaceAll("ForgeLink", FORGELINC_NAME)
    .replaceAll("LincForge", FORGELINC_NAME)
    .replaceAll("LinkForge", FORGELINC_NAME);
}

export function displayBusinessName(businessOrKey, maybeBusiness) {
  const business = typeof businessOrKey === "string" ? maybeBusiness : businessOrKey;
  const key = typeof businessOrKey === "string"
    ? businessOrKey
    : (business?.key || business?.slug);
  if (KNOWN_BUSINESS_NAMES[key]) return KNOWN_BUSINESS_NAMES[key];
  return displayProductText(business?.name || key || "");
}
